var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducational(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.751,
    viewBox: "0 0 18 13.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-book",
    transform: "translate(0 -35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104264",
    "data-name": "Group 104264",
    transform: "translate(0 35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104263",
    "data-name": "Group 104263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64146",
    "data-name": "Path 64146",
    d: "M35.475,35.049h0a.635.635,0,0,0-.451.187.641.641,0,0,0-.19.457v9.659a.646.646,0,0,0,.645.644,7.968,7.968,0,0,1,5.744,2.129V38.017a.617.617,0,0,0-.089-.326C39.711,35.4,36.978,35.053,35.475,35.049Z",
    transform: "translate(-32.722 -35.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64147",
    "data-name": "Path 64147",
    d: "M163.14,45.351V35.692a.643.643,0,0,0-.641-.644h0c-1.5,0-4.236.352-5.658,2.642a.617.617,0,0,0-.088.326V48.124a7.968,7.968,0,0,1,5.744-2.129A.646.646,0,0,0,163.14,45.351Z",
    transform: "translate(-147.251 -35.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64148",
    "data-name": "Path 64148",
    d: "M178.445,71.8h-.467v8.075a1.648,1.648,0,0,1-1.643,1.644,7.144,7.144,0,0,0-4.854,1.657,15.506,15.506,0,0,1,6.819.132.644.644,0,0,0,.788-.628V72.445A.645.645,0,0,0,178.445,71.8Z",
    transform: "translate(-161.089 -69.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64149",
    "data-name": "Path 64149",
    d: "M1.111,79.876V71.8H.644A.645.645,0,0,0,0,72.445V82.681a.644.644,0,0,0,.788.628,15.5,15.5,0,0,1,6.819-.132A7.144,7.144,0,0,0,2.754,81.52,1.648,1.648,0,0,1,1.111,79.876Z",
    transform: "translate(0 -69.574)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducational);
export default __webpack_public_path__ + "static/media/educational.6ea42725ef96ef5efef359704cf4cd0d.svg";
export { ForwardRef as ReactComponent };